import { lazyMountAndShowFullOptions } from 'owa-options-view';

export default function showFilePickerOption(targetWindow: Window = window) {
    lazyMountAndShowFullOptions.importAndExecute('mail', 'attachments', null, targetWindow);
}
